export const INITIAL_STATE = {
    features: {
        show_note_field: false,
        hide_description_field: false,
    },
    loading: false,
    error: null,
    loaded: false,
};

export const featuresReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'LOAD_FEATURES_REQUEST': {
            return {
                ...state,
                loading: true,
                error: null,
            };
        }
        case 'LOAD_FEATURES_SUCCESS': {
            return {
                ...state,
                features: action.payload,
                loading: false,
                error: null,
                loaded: true,
            };
        }
        case 'LOAD_FEATURES_FAILURE': {
            return {
                ...state,
                loading: false,
                error: action.error,
                loaded: true,
            };
        }
        case 'RESET_FEATURES': {
            return INITIAL_STATE;
        }
        default:
            return state;
    }
};

export default featuresReducer;
